import { createContext, useContext, type ReactNode } from 'react'

import type { Db } from '@/lib/db'

const DbContext = createContext<Db | null>(null)

export function DbProvider(props: { db: Db; children: ReactNode }) {
  return (
    <DbContext.Provider value={props.db}>{props.children}</DbContext.Provider>
  )
}

export function useDb(): Db {
  const db = useContext(DbContext)
  if (!db) {
    throw new Error('useDb must be used within a DbProvider')
  }
  return db
}


/** Like {@link useDb} but null outside a provider (tests, stories). */
export function useOptionalDb(): Db | null {
  return useContext(DbContext)
}
